import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";

import RaccourciProductList from "../../Components/Caisses/ProductsRaccourcis/RaccourciProductList";

import {
  ListCartes,
  findCartesApi,
} from "../../_App/Redux/Slices/cartes/carteSlice";
import CaisseCartesList from "../../Components/Caisses/Cartes/CaisseCartesList";
import {
  ListCategories,
  ListCategoriesByCarte,
  findCategoriesApi,
} from "../../_App/Redux/Slices/categories/categorieSlice";
import {
  ListSousCategories,
  ListSousCategoriesByCategorie,
  findSousCategoriesApi,
} from "../../_App/Redux/Slices/souscategories/souscategorieSlice";
import {
  Display,
  Filter,
  changeDisplay,
  layout,
  selectedTable,
} from "../../_App/Redux/Slices/Caisse/CaisseSlice";

import CaisseCategoriesList from "../../Components/Caisses/Categories/CaisseCategoriesList";
import CaisseSousCategoriesList from "../../Components/Caisses/SousCategories/CaisseSousCategoriesList";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import {
  ListRaccourci,
  findProductRaccourciByOrganisationApi,
} from "../../_App/Redux/Slices/product_raccourci/ProductRaccourciSlice";
import NavbarCaisse from "../../_Layouts/Navbar/NavbarCaisse";
import {
  SelectedOrganisationId,
  selectJournalCaisse,
  selectUser,
  selectedSessionJournal,
  societeId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import {
  currentpage,
  findArticlebysocieteApi,
  ListArticles,
  totalPages,
} from "../../_App/Redux/Slices/article/articleSlice";
import CaisseArticlesList from "../../Components/Caisses/Articles/CaisseArticlesList";

import { useNavigate } from "react-router-dom";
import Loader from "../../_Layouts/Loader/Loader";
import { ArticleType } from "../../_App/Types/Entites/ArticleType";
import { SousCategorie } from "../../_App/Types/Entites/SousCategorie";
import { parametrageCaisse } from "../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
import BarcodeOnlyCaissePage from "./BarcodeOnlyCaissePage";
import { NotificationApi } from "../../_App/Redux/Slices/notif/NotifSlice";

// Dispatching the action

const CaissePage = () => {
  const dispatch = useAppDispatch();
  const productsRaccourcis = useAppSelector(ListRaccourci);
  const currentOrganisation = useAppSelector(SelectedOrganisationId);
  const societe = useAppSelector(societeId);

  //
  const navigate = useNavigate();
  const journalCaisse = useAppSelector(selectJournalCaisse);
  const sessionJournal = useAppSelector(selectedSessionJournal);
  const user = useAppSelector(selectUser);

  const isCaisseClosed =
    !journalCaisse ||
    journalCaisse.cloture ||
    !sessionJournal ||
    sessionJournal.cloture;

  useEffect(() => {
    if (isCaisseClosed || user?.role_id?.libelle !== "onlineSale") {
      // navigate("/HomeCaisse");
    }
  }, [isCaisseClosed, navigate]);

  //
  // const cartes = useAppSelector(ListCartes);
  // const categories = useAppSelector(ListCategories);
  // const categoriesByCarte = useAppSelector(ListCategoriesByCarte);

  const sousCategories = useAppSelector(ListSousCategories);
  const caisseParametrages = useAppSelector(parametrageCaisse);

  const sousCategoriesByCategorie = useAppSelector(
    ListSousCategoriesByCategorie
  );
  const articles = useAppSelector(ListArticles);
  const [list_Article, setlist_Article] = useState<ArticleType[]>();
  const [indexArticle, setindexArticle] = useState(0);
  const [list_SousCAt, setlist_SousCat] = useState<SousCategorie[]>();
  const [indexSousCat, setindexSousCat] = useState(0);

  const filter = useAppSelector(Filter);
  const display = useAppSelector(Display);
  const Layout = useAppSelector(layout);
  const selectedtable = useAppSelector(selectedTable);

  const handleDisplayChange = async ({
    displayColLeft,
    colRight,
    containerRight,
  }: any) => {
    dispatch(
      changeDisplay({
        colLeft: display.colLeft,
        containerLeft: display.containerLeft,
        displayColLeft: displayColLeft,
        colRight: colRight,
        containerRight: containerRight,
      })
    );
  };
  const [isLoading, setIsLoading] = useState(true); // Add loading state

  useEffect(() => {
    const selectedArticles = articles.slice(indexArticle, indexArticle + 10);
    setlist_Article(selectedArticles);
  }, [articles, indexArticle]);
  useEffect(() => {
    const selectedSousCategories = sousCategories.slice(
      indexSousCat,
      indexSousCat + 10
    );
    setlist_SousCat(selectedSousCategories);
  }, [sousCategories, indexSousCat]);
  const current_page = useAppSelector(currentpage);
  const totalpages = useAppSelector(totalPages);
  const [index, setindex] = useState(!current_page ? 1 : current_page);
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (currentOrganisation) {
          setIsLoading(true); // Set loading to true before making API calls

          // Dispatch API calls
          await Promise.all([
            dispatch(
              findProductRaccourciByOrganisationApi(currentOrganisation)
            ),

            dispatch(findArticlebysocieteApi({ id: societe, index: index })),
          ]);

          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [currentOrganisation]);

  return caisseParametrages && caisseParametrages.barcodeOnly ? <></> : <></>;
};

export default CaissePage;
